import * as events from "events";

import { Injectable } from "@angular/core";
import { Http } from "@angular/http";

import { Domain as WebsideDomain } from "../../../lib/Domain/Webside";
@Injectable()
export class EnergystorageService extends events.EventEmitter {
  // \lib\Server\Webside\route\api\userRoute.ts
  constructor(private http: Http) { super(); }
  public async List(): Promise<WebsideDomain.IProduct[]> {
    const result = await this.http.get("/api/energystorage/list")
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IProduct[];
    } else {
      throw new Error(`${result.message}`);
    }
  }

  public async data(uuid: string, start: Date, ): Promise<WebsideDomain.IEnergyStorageSystem> {
    const result = await this.http.post("/api/energystorage/data", { uuid, start })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IEnergyStorageSystem;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async rawdata(uuid: string): Promise<WebsideDomain.IEnergyStorageSystem> {
    const result = await this.http.post("/api/energystorage/rawdata", { uuid })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IEnergyStorageSystem;
    } else {
      throw new Error(`${result.message}`);
    }
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/energystorage.service.ts